<template>
  <fragment>
    <c-generic-section top-divider>
      <div class="container-xs">
        <h2 class="mt-0">Get the next phase of your web app project kickstarted by making a payment.</h2>
        <p class="strong">This page lets you make a single one-off payment for {{amount}}.</p>
        <p>You're seeing this page after we've already worked together on the web app for {{companyName}}.</p>
        <p></p>
        <p>Your payment covers the following:</p>
        <ul>
          <li>All the work we discussed and confirmed via email.</li>
          <li>During our work, you'll receive regular status updates. We'll stay in touch by email mostly, and by phone sometimes. Regular communication (no long delays) is key.</li>
          <li>
            I
            <router-link to="/guarantee">guarantee all my work</router-link>
            . I'll be available to you after the project is delivered for additional projects, or to provide ongoing support for {{companyName}}.
          </li>
        </ul>

        <CButton
          tag="button"
          wide
          color="primary"
          @click="redirectToCheckout"
          :loading="loading"
          :disabled="loading"
        >Checkout Now</CButton>
        <ul class="small no-bullets">
          <li>🔒 This payment link is secured by Stripe's bank-grade AES-256 encryption.</li>
          <li>Submitting this payment cements your project on my project calendar.</li>
          <li>As soon as this payment goes through, you will receive a receipt in your inbox.</li>
        </ul>
      </div>
    </c-generic-section>
  </fragment>
</template>

<script>
// import layout
import CLayout from "@/layouts/LayoutAlternative.vue";
// import section header
// import sections
import CGenericSection from "@/components/sections/GenericSection.vue";
import CButton from "@/components/elements/Button.vue";
import { loadStripe } from "@stripe/stripe-js";
const stripePromise = loadStripe("pk_live_56ysX32MWcIijXt0kBWJJrL2");
// const stripePromise = loadStripe("pk_test_5brbcIWHvtiDTXoVI0QW4a7X");
export default {
  name: "ProjectPaymentMicro",
  components: {
    CGenericSection,
    CButton,
  },
  data() {
    return {
      amount: "$3,750 USD",
      loading: false,
    };
  },
  created() {
    this.$emit("update:layout", CLayout);
  },
  computed: {
    companyName() {
      if (this.$route && this.$route.query.company)
        return this.$route.query.company;
      return "your business";
    },
  },
  methods: {
    async redirectToCheckout() {
      this.loading = true;
      const stripe = await stripePromise;
      const response = await fetch("/.netlify/functions/stripe-checkout", {
        method: "POST",
      });

      const session = await response.json();

      // When the customer clicks on the button, redirect them to Checkout.
      await stripe.redirectToCheckout({
        sessionId: session.id,
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.strong {
  font-weight: bold;
}

ul.small {
  margin-top: 1rem;
}

.text-center {
  text-align: center;
}

ul.no-bullets {
  padding-left: 0;
}

ul.no-bullets li {
  margin-left: 0;
  list-style: none;
}
ul.small li {
  margin-top: 0.75rem;
  margin-bottom: 0rem;
  line-height: 1.5;
}
.small {
  font-size: 75%;
}
</style>